export default __webpack_public_path__ + "static/media/dooh_inferred_path.393469a8.svg";